import { useRef, useState } from 'react'
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Autocomplete, Chip, MenuItem, Select } from '@mui/material';
import { CancelIcon, ReadOnlyIcon, SecureFileDownloadIcon, SecureFileEditIcon, UploadFileIcon } from '../../icon';
import { DialogHeaders, ToasterTexts, buttonLabels } from '../shared/constants';
import AddAccessListTextComponent from './add-access-list.component';
import ButtonComponent from '../shared/button/button.component';
import { UtilityService } from '../../services/UtilityService';
import { SecureFileService } from '../../services/SecureFileService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { DisplayMediaIcon } from './display-media.component';
import { DocumentPermissions, FaceAuthenticationModel, FaceRegistrationInviteLinkStatus, SecureFileModel, SecureFileStatusModel, ValidityType } from '../../models/secure-file';
import Config from '../../config';
import { UserService } from '../../services/UserService';
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { PlanMetrics } from '../../models/plan-metrics.model'
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';

interface Props {
    OnClose: (isConfim: boolean, data?: any) => void;
    Show: boolean;
    SecureFiles: SecureFileModel[];
}

const UploadSecureFile = (props: Props) => {
    let ValidityPeriod = [
        { Name: "One Day", Value: ValidityType.ONE_DAY },
        { Name: "One Week", Value: ValidityType.ONE_WEEK },
        { Name: "One Month", Value: ValidityType.ONE_MONTH }
    ]
    let documentPermissions = [
        { Name: "Read Only", Value: DocumentPermissions.READONLY, Icon: <ReadOnlyIcon /> },
        { Name: "Download", Value: DocumentPermissions.DOWNLOAD, Icon: <SecureFileDownloadIcon /> }
    ]

    const AllowedExtensions = [
        "audio/",
        "video/",
        "image/",
        "application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "text/plain"
    ];

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const FaceAuthenticationFiles: FaceAuthenticationModel[] = useSelector(selector.faceAuthenticatonFiles);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    const [selectedFaces, setSelectedFaces] = useState<FaceAuthenticationModel[]>([])
    const [fileUpload, setFileupload] = useState<any>("")
    const [addedAccesslist, setAddedAccessList] = useState<any>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isValidityPeriod, setisValidityPeriod] = useState(ValidityType.ONE_DAY)
    const [documnetPermisson, setDocumnetPermisson] = useState(DocumentPermissions.READONLY)
    const [fileUploadError, setFileUploadError] = useState<string>("")


    const onChange = (e) => {
        const file = e.target.files?.[0];
        if (e.target.files[0].size > 20000000) {
            setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", "20"), ToasterType.DANGER)
        }
        else if (e.target.files) {
            setFileupload(e.target.files[0])
            if (documnetPermisson === DocumentPermissions.READONLY) {
                const isValid = AllowedExtensions.some(ext => file.type.startsWith(ext));
                if (!isValid) {
                    setFileUploadError("Invalid file type. Please upload .audio .video .image .pdf .docx .txt")
                    return
                }
            }
        }
    }

    const formatFileSize = (size: number) => {
        return size < 1024 * 1024 ? `${(size / 1024).toFixed(2)} KB` : `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const isVaild = () => {
        let valid = addedAccesslist?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !x)
        return valid?.length > 0 ? false : true
    }

    const addAccessListHandel = (list) => {
        setAddedAccessList(list)
    }

    const formSubmit = () => {
        let access = addedAccesslist?.map(x => UtilityService.isValidEmail(x) && x).filter(x => !!x)
        let activeFiles = props.SecureFiles.filter(x => x.Status === SecureFileStatusModel.Active)
        setIsLoading(true)
        if (activeFiles?.length > 20) {
            setToast("Currently this feature is in its beta, and you are limited to having a maximum of 20 active secured files ", ToasterType.DANGER)
            setIsLoading(false)
        }
        else {
            const organizationId = UserService.getCurrentUserOrgId()
            let uploadData = new FormData();
            uploadData.append("userId", UserService.getCurrentUserId())
            uploadData.append("userName", JSON.parse(localStorage.getItem("current-user")).firstName)
            uploadData.append("sharedEmails", !!access ? access : [])
            uploadData.append("file", fileUpload)
            uploadData.append("redirectURL", Config.APP_FE_URL)
            const getExpDays = (validity: ValidityType | null) => {
                switch (validity) {
                    case ValidityType.ONE_DAY:
                        return 1
                    case ValidityType.ONE_WEEK:
                        return 7
                    case ValidityType.ONE_MONTH:
                        return 30
                    default:
                        return 1
                }
            }
            uploadData.append("expDays", getExpDays(isValidityPeriod).toString())
            uploadData.append("sharedFaces", selectedFaces.map(face => face.ContactPhoneNumber?.replace("+", "")).join(','))
            uploadData.append("organizationId", organizationId)
            uploadData.append("phoneNumber", UserService.getUserPhoneNumber().replace("+", ""))
            uploadData.append("isReadOnly", documnetPermisson.toString())


            SecureFileService.uploadFile(uploadData).then((res) => {
                if (!!res.data) {
                    if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                        setIsLoading(false)
                        props.OnClose(true, res.data);
                        setToast(res.data.message, ToasterType.SUCCESS)
                    }
                    else {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    }
                }
                else {
                    setIsLoading(false)
                    props.OnClose(true, res.data);
                    setToast(res.data.message, ToasterType.SUCCESS)
                }
            }).catch((err) => {
                setIsLoading(false)
                setToast(err.response.data.error, ToasterType.DANGER)
            })
        }
    }

    const handleCancel = () => {
        setFileupload("")
        setFileUploadError("")
        const fileInput = document.getElementById("Upload") as HTMLInputElement
        if (fileInput) fileInput.value = ""
    }

    const handlValidityPeriod = (e: any, value: any) => {
        if (value) {
            setisValidityPeriod(value?.Value)
        }
    }

    const handleDocumentPermissions = (value) => {
        if (value) {
            if (value === DocumentPermissions.READONLY && !!fileUpload) {
                const isValid = AllowedExtensions.some(ext => fileUpload.type.startsWith(ext));
                if (isValid) {
                    setDocumnetPermisson(value)
                }
                else {
                    setDocumnetPermisson(value)
                    setFileUploadError("Invalid file type. Please upload .audio .video .image .pdf .docx .txt")
                }
            }
            else {
                setFileUploadError("")
                setDocumnetPermisson(value)
            }
        }
    }

    const handleSelectionChange = (event, newValue) => {
        setSelectedFaces(newValue?.filter((x) => typeof x !== "string"))
    }

    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={props.Show}
            // onClose={() => { props.OnClose(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: `br-2 w-p-36 ${IsDarkMode ? "" : "dialogue-shadow"} ` }}
            disableEscapeKeyDown
        >
            <DialogTitle className={`pb-1 pt-2 px-4 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                <div className={`d-flex justify-between align-center ${IsDarkMode ? "" : "color-settings-heading"} h3-semibold`}>
                    <span>
                        {DialogHeaders.UPLOAD}
                    </span>
                    <CancelIcon onClick={() => props.OnClose(false)} className="c-pointer" />
                </div>
            </DialogTitle>
            <DialogContent className={`px-4 py-2 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                <form
                    noValidate
                    autoComplete="no"
                >
                    <div className='bg-color-conv-hist-bg h-20 d-flex align-center justify-center br-2'>
                        <div
                            onClick={() => {
                                if (!fileUpload) {
                                    fileInputRef.current?.click();
                                }
                            }}
                            className={`d-flex flex-direction align-center justify-center ${!fileUpload && "c-pointer"} ${(!!fileUpload && !fileUploadError) ? '' : `bg-color-secondary m-2 h-p-80 ${!!fileUploadError ? "b-around-danger" : "import-contacts-border"}`} br-2 w-p-100`}
                        >
                            {!fileUpload &&
                                <>
                                    <UploadFileIcon />
                                    <input
                                        id="Upload"
                                        type="file"
                                        name='fileupload'
                                        ref={fileInputRef}
                                        className="p-absolute t-0 l-0 opacity-0 c-pointer"
                                        onChange={onChange}
                                        accept={documnetPermisson === DocumentPermissions.READONLY ? "audio/*,video/*,image/*,.pdf,.docx,.txt" : ""}
                                    />
                                    <span className={`h5-regular ${IsDarkMode ? "" : "color-disabled-btn"} d-flex align-center justify-center`}>
                                        {documnetPermisson === DocumentPermissions.READONLY ? "Upload your file .audio .video .image .pdf .docx .txt" : "Upload your file"}
                                    </span>
                                </>
                            }

                            {!!fileUploadError && <span className='h6-medium color-primary-danger'>{fileUploadError}</span>}

                            {!!fileUpload &&
                                <div className={`h5-regular ${!fileUploadError ? "bg-color-secondary" : "bg-color-photosensitivity-warning"} d-flex justify-center align-center mt-1 br-2 w-p-90`}>
                                    <div className="m-1 w-p-7 d-flex justify-center align-center">
                                        <DisplayMediaIcon FileName={fileUpload?.name} />
                                    </div>
                                    <span className={`d-flex w-p-75 h6-regular`}>
                                        {fileUpload?.name}
                                        <span className='ml-3'>{formatFileSize(fileUpload?.size)}</span>
                                    </span>
                                    <div className="d-flex justify-center align-center w-p-18">
                                        {documnetPermisson === DocumentPermissions.READONLY ? <ReadOnlyIcon className='mr-2' /> : <SecureFileDownloadIcon className='mr-2' />}
                                        <CancelIcon onClick={handleCancel} className="c-pointer" />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="d-flex py-2 w-p-100 justify-between align-center">
                        <div className="flex-direction w-p-31">
                            <div className="h5-semibold">File Name</div>
                            <TextField
                                size='small'
                                fullWidth
                                variant="outlined"
                                className='mt-1'
                                disabled
                                placeholder='Default File Name'
                                value={fileUpload?.name || ""}
                                InputProps={{ classes: { input: `h4-regular ${IsDarkMode ? "color-primary-acent" : ""}` } }}
                            />
                        </div>
                        <div className="w-p-30">
                            <div className="h5-semibold mb-1">Validity Period</div>
                            <Autocomplete
                                size="small"
                                classes={{ input: `h4-regular ${IsDarkMode ? "" : "color-text-field-font"} `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={ValidityPeriod}
                                disableClearable
                                getOptionLabel={(option) => option?.Name}
                                onChange={handlValidityPeriod}
                                value={ValidityPeriod.find(x => x.Value === Number(isValidityPeriod))}
                                renderOption={(defaultprops, option, { selected }) => (
                                    <li {...defaultprops} className={`${defaultprops.className} c-pointer h4-regular ${IsDarkMode ? "" : "color-primary-dark"} p-1 ml-1 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                        {option?.Name}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} name="validity period" placeholder="select" required variant="outlined" />}
                            />
                        </div>
                        <div className="w-p-33">
                            <div className="h5-semibold mb-1">Document Permissions</div>
                            <Select
                                size='small'
                                value={documnetPermisson || ""}
                                onChange={(event) => handleDocumentPermissions(event.target.value)}
                                renderValue={(selected) => {
                                    const selectedOption = documentPermissions.find((x) => x.Value === selected);
                                    return (
                                        <div className="d-flex">
                                            <div className="mr-1 d-flex align-center">{selectedOption.Icon}</div>
                                            <span>{selectedOption.Name}</span>
                                        </div>
                                    )
                                }}
                            >
                                {documentPermissions.map((option) => (
                                    <MenuItem key={option.Value} value={option.Value}>
                                        <div className="d-flex">
                                            <div className="mr-1 d-flex align-center">{option.Icon}</div>
                                            <span>{option.Name}</span>
                                        </div>
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <span className='mt-1 px-2'>
                        <AddAccessListTextComponent
                            PlaceHolder={"People with access: "}
                            AddAccessListHandel={addAccessListHandel}
                        />
                    </span >
                    {PlanMetrics?.HasAccessToFaceVault && <div className='d-flex align-end justify-between'>
                        <div className='w-p-90'>
                            <Autocomplete
                                multiple
                                freeSolo
                                fullWidth
                                disableClearable
                                className="field-border"
                                options={FaceAuthenticationFiles.filter(x => x.Status === FaceRegistrationInviteLinkStatus.Registered)}
                                getOptionLabel={(option) => `${option.Name} ${option.ContactPhoneNumber || ""}`}
                                onChange={handleSelectionChange}
                                renderOption={(props, option) => (
                                    <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div className='ml-2 h4-regular'>{option.Name}</div>
                                        <div className='mr-2 h4-regular'>{option.ContactPhoneNumber}</div>
                                    </li>
                                )}
                                renderTags={(value, getTagProps) => {
                                    return value?.filter((x) => typeof x !== "string")?.map((option, index) => (
                                        <Chip
                                            classes={{ colorPrimary: "custom-color-chip-1" }}
                                            key={index}
                                            label={!!option.Name?.trim() ? option.Name : option.ContactPhoneNumber}
                                            {...getTagProps({ index })}
                                        />
                                    ));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder={selectedFaces?.length > 0 ? "" : "Who has Face authentication access:"}
                                    />
                                )}
                            />
                        </div>
                        <SecureFileEditIcon />
                    </div>
                    }
                </form>
            </DialogContent>
            <DialogActions className={`pr-4 pb-4 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-primary-background"}`}>
                <ButtonComponent ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} ClassName='mr-1' OnClick={(e) => { e.stopPropagation(); e.preventDefault(); props.OnClose(false) }} />
                <ButtonComponent ButtonLabel={buttonLabels.UPLOAD} Variant={(!!fileUpload && isVaild() && !fileUploadError) ? 'primary-btn-small' : "disabled-btn-small"} OnClick={formSubmit} Loading={isLoading} />
            </DialogActions>
        </Dialog>
    )
}
export default UploadSecureFile